/**
 * ============================================================
 * Mining Survey WebGIS
 * Map Module
 * ============================================================
 */

import L from "leaflet";

import CONFIG from "../config/config.js";

import AppState from "../core/app.js";

class Map {
    constructor() {
        this.trackLayer = null;

        this.trackPolyline = null;

        this.startMarker = null;

        this.endMarker = null;

        this.waypointLayer = null;
    }

    init() {
        console.log("Initializing Map...");

        this.createMap();

        this.createBaseMap();

        this.createScale();

        this.createTrackLayer();

        this.createWaypointLayer();
    }

    createMap() {
        AppState.map = L.map("map", {
            center: CONFIG.MAP.CENTER,

            zoom: CONFIG.MAP.ZOOM,

            minZoom: CONFIG.MAP.MIN_ZOOM,

            maxZoom: CONFIG.MAP.MAX_ZOOM,

            zoomControl: false,
        });

        AppState.map.on("dragstart", () => {
            AppState.followMode = false;

            this.updateFollowButton();
        });
    }
    createBaseMap() {
        AppState.layers.base.osm = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap",
        });

        //AppState.layers.base.osm.addTo(AppState.map);
    }

    createScale() {
        L.control
            .scale({
                imperial: false,
            })
            .addTo(AppState.map);
    }

    updatePosition(position) {
        const latlng = [position.latitude, position.longitude];

        if (!AppState.marker) {
            const icon = L.divIcon({
                className: "gps-div-icon",

                html: `

<div class="gps-marker">

    <!-- Pulse -->
    <div class="gps-pulse"></div>

    <!-- Position -->
    <div class="gps-base">

        <div class="gps-dot"></div>

    </div>

    <!-- Heading -->
    <div class="gps-heading">

        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48">

            <!-- Direction Cone -->
            <path
                class="gps-cone"
                d="
                    M24 24
                    L10 4
                    Q24 -6 38 4
                    Z
                "/>

            <!-- Arrow -->
            <path
                class="gps-arrow"
                d="
                    M24 4
                    L15 22
                    L22 18
                    L24 8
                    L26 18
                    L33 22
                    Z
                "/>

        </svg>

    </div>

</div>

            `,

                iconSize: [48, 48],

                iconAnchor: [24, 24],
            });

            AppState.marker = L.marker(latlng, {
                icon,
            }).addTo(AppState.map);

            AppState.accuracyCircle = L.circle(latlng, {
                radius: position.accuracy,

                color: "#1565C0",

                fillColor: "#2196F3",

                fillOpacity: 0.08,

                weight: 2,
            }).addTo(AppState.map);
        } else {
            AppState.marker.setLatLng(latlng);

            AppState.marker.setZIndexOffset(1000);

            AppState.accuracyCircle.setLatLng(latlng).setRadius(position.accuracy);
        }

        this.updateHeading(position);

        if (AppState.followMode) {
            AppState.map.panTo(
                latlng,

                // currentZoom,

                {
                    animate: true,
                },
            );
        }
    }
    updateHeading(position) {
        const markerElement = AppState.marker?.getElement();

        if (!markerElement) return;

        const headingLayer = markerElement.querySelector(".gps-heading");

        if (!headingLayer) return;

        const speed = (position.speed ?? 0) * 3.6;

        if (speed < 1) {
            return;
        }

        const heading = position.heading;

        if (heading === null || heading === undefined) {
            return;
        }

        headingLayer.style.transform = `rotate(${heading}deg)`;
    }

    renderTrack(points) {
        if (!AppState.map) return;

        if (!this.trackLayer) {
            this.createTrackLayer();
        }

        if (points.length === 0) {
            this.clearTrack();

            return;
        }

        const latlngs = points.map((point) => [point.latitude, point.longitude]);

        // Start Marker
        if (!this.startMarker) {
            this.startMarker = L.circleMarker(latlngs[0], {
                radius: 7,
                color: "#00C853",
                fillColor: "#00E676",
                fillOpacity: 1,
                weight: 2,
            }).addTo(this.trackLayer);
        }

        // Track Line
        if (!this.trackPolyline) {
            this.trackPolyline = L.polyline(latlngs, {
                color: "#1565C0",

                weight: 4,

                opacity: 0.9,
            }).addTo(this.trackLayer);
        } else {
            this.trackPolyline.setLatLngs(latlngs);
        }
    }

    locateCurrentPosition() {
        if (!AppState.currentPosition) return;

        AppState.followMode = true;

        this.updateFollowButton();

        AppState.map.flyTo(
            [AppState.currentPosition.latitude, AppState.currentPosition.longitude],

            CONFIG.GPS.FOLLOW_ZOOM,

            {
                animate: true,

                duration: 1,
            },
        );
    }

    updateFollowButton() {
        const btn = document.getElementById("btnFollow");

        if (!btn) return;

        if (AppState.followMode) {
            btn.classList.add("active");
        } else {
            btn.classList.remove("active");
        }
    }

    createTrackLayer() {
        if (!AppState.map) {
            console.warn("Map belum siap.");

            return;
        }

        if (this.trackLayer) {
            return;
        }

        this.trackLayer = L.layerGroup().addTo(AppState.map);
    }

    clearTrack() {
        if (!this.trackLayer) return;

        this.trackLayer.clearLayers();

        this.trackPolyline = null;

        this.startMarker = null;

        this.endMarker = null;
    }

    createWaypointLayer() {
        if (!AppState.map) return;

        this.waypointLayer = L.layerGroup().addTo(AppState.map);
    }

    addWaypointMarker(waypoint) {
        if (!this.waypointLayer) return;
        /*
        const icon = L.divIcon({
            className: "waypoint-icon",

            html: `
            <div class="waypoint-marker">

                📌

            </div>
        `,

            iconSize: [32, 32],

            iconAnchor: [16, 32],
        });
*/
        const marker = L.marker(
            [waypoint.latitude, waypoint.longitude],

            {
                // icon,
                zIndexOffset: 500,
            },
        ).addTo(this.waypointLayer);

        marker.bindTooltip(
            waypoint.name,

            {
                permanent: false,

                direction: "top",

                offset: [0, -18],
            },
        );

        marker.bindPopup(`
            <b>${waypoint.name}</b><br>
            ${waypoint.description || "-"}<br><br>

            Accuracy : ${waypoint.accuracy.toFixed(1)} m<br>
            Altitude : ${(waypoint.altitude ?? 0).toFixed(2)} m
        `);

        waypoint.marker = marker;
    }

    clearWaypoints() {
        if (!this.waypointLayer) return;

        this.waypointLayer.clearLayers();
    }
}

export default new Map();
